export const Gray = {
  100: 'var(--gray100)',
  200: 'var(--gray200)',
  300: 'var(--gray300)',
  400: 'var(--gray400)',
  500: 'var(--gray500)',
}

export const White = 'var(--white)'
export const Neutral = 'var(--neutral-theme)'

export const Orange = {
  500: '#FF7A00',
  600: '#EB7000',
  700: '#FFC2E7',
}

export const Green = {
  400: '#20C05D',
  500: '#00AA4F',
}

export const Yellow = {
  300: '#FFF7D9',
  400: '#FFC700',
  500: '#FFBA00',
}

export const Red = {
  500: '#FD4F47',
}

export const Status = {
  Error: {
    100: '#FEF0ED',
    500: '#F56A50',
  },
}

export const INPUT_HEIGHT = '48px'
